module.exports = __webpack_public_path__ + "img/footer_logo.88568105.png";